var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.361 7.873a.96.96 0 0 1 .974-.946h10.603a.96.96 0 0 1 .973.946v6.677a.96.96 0 0 1-.973.946H2.335a.96.96 0 0 1-.974-.946zM5.43 5.526h7.302c1.612 0 2.528 1.005 2.528 2.572v3.477h1.453a.96.96 0 0 0 .973-.946V4.28a.96.96 0 0 0-.973-.945H6.402a.96.96 0 0 0-.973.946zM4.015 4.58c0-1.568 1.021-2.458 2.633-2.458h9.731c1.612 0 2.621.89 2.621 2.458v5.693c0 1.568-.723 2.637-2.336 2.637H15.26v1.427c0 1.567-.916 2.541-2.528 2.541H2.512c-1.612 0-2.49-.974-2.49-2.541V8.364c-.185-1.781.83-2.838 2.734-2.838h1.26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.c21bfc23d9e82926e5bca99b2a31ffae.svg";
export { ForwardRef as ReactComponent };